import { ReactElement, Fragment } from 'react';

import { Box } from '@twilio-paste/core/box';

import { Separator } from '@twilio-paste/core/separator';
import { Text } from '@twilio-paste/core/text';

import { oscLayoutCopy } from '@twiliointernal/e2-commons-shared-definitions';
import { constants } from '../definitions';
import twilioLogoMarkWhite from '../../../../assets/twilio-logomark-white.svg';
import styles from '../layout.module.css';

const Footer = (): ReactElement => {
  const renderFooterLink = (label: string, url: string): ReactElement => (
    <Box
      as="a"
      className={styles.footerLink}
      color="colorTextInverse"
      fontSize="fontSize20"
      href={url}
      _hover={{
        color: 'colorTextIconInverse',
      }}
    >
      {label}
    </Box>
  );

  const renderFooterLinks = (): ReactElement[] =>
    constants.footerLinks.map(({ label, url }) => {
      const isLast = label === constants.footerLinks.at(-1)?.label;

      return (
        <Box as="span" display="flex" key={label}>
          {renderFooterLink(label, url)}

          {!isLast && (
            <Separator horizontalSpacing="space40" orientation="vertical" />
          )}
        </Box>
      );
    });

  const renderReCaptchaLinks = (): ReactElement[] =>
    constants.reCaptchaLinks.map(({ label, url }, index) => (
      <Fragment key={label}>
        {index === 1 && ' and '}
        {renderFooterLink(label, url)}
        {index === constants.reCaptchaLinks.length - 1 && ' apply.'}
      </Fragment>
    ));

  return (
    <Box
      as="footer"
      gridArea="footer"
      className={styles.footer}
      backgroundColor="colorBackgroundInverse"
    >
      <Box
        as="img"
        src={twilioLogoMarkWhite}
        width="sizeSquare90"
        alt="Twilio logo"
      />

      <Box as="div" className={styles.footerLinkContainer}>
        {renderFooterLinks()}
      </Box>

      <Box as="div" className={styles.footerCopyright}>
        <Text as="p" color="colorTextInverse" fontSize="fontSize20">
          {oscLayoutCopy.footer.copyright}
        </Text>

        <Text as="p" color="colorTextInverse" fontSize="fontSize20">
          {oscLayoutCopy.footer.allRightsReserved}
        </Text>

        <Text as="p" color="colorTextInverse" fontSize="fontSize20">
          {oscLayoutCopy.footer.reCaptcha.protectedByGoogle}
          {renderReCaptchaLinks()}
        </Text>
      </Box>
    </Box>
  );
};

export default Footer;
